import React, { useEffect } from 'react';
import {Headline4} from 'ellow-web-ui-components-library';
import {FromHead} from 'ellow-web-ui-components-library';
import Styles from "../dashboard/styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import { Typography } from "@progress/kendo-react-common"; 
import { useLocation } from 'react-router-dom';
import { viewedpageMixpanel } from '../../utils/mixpanel';
import pageGraphics from "../../assets/images/pageGraphics.svg"

function DashBoard() {
  const location = useLocation();
  
  useEffect(() => {
    viewedpageMixpanel();
   },[]);

  return (

    <section className={Styles.verifiWrapper}>
      <div className={Styles.header}>
        <img src={ellowLogo} alt="ellow.io" />
      </div>
      <div className={Styles.errorMessage}> 
        <img src={pageGraphics} alt='pagegraphics'/>
        <h1>{location.state===1? 'We are processing your details. Our team will get in touch with you soon':'Our team will get in touch with you soon'}</h1>
        <p>In case of any queries , Please reach out to us at <br></br><a href="mailti:team@ellow.io" className={Styles.link}>team@ellow.io</a></p>
      </div>
    </section>
  )
}

export default DashBoard